"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearRedoMigrationNoticeDismissals = exports.dismissRedoMigrationNotice = exports.isRedoMigrationNoticeDismissed = exports.getRedoMigrationNoticeDismissKey = exports.MIGRATED_TO_REDO_FLAG_KEY = exports.REDO_MIGRATION_MODAL_ID = void 0;
const DISMISS_KEY_PREFIX = 'redoMigrationNoticeDismissed:';
exports.REDO_MIGRATION_MODAL_ID = 'redo-migration-modal';
/** LaunchDarkly flag key (kebab-case). Accessed via useFlags().migratedToRedo. */
exports.MIGRATED_TO_REDO_FLAG_KEY = 'migrated-to-redo';
const getRedoMigrationNoticeDismissKey = (accountId) => `${DISMISS_KEY_PREFIX}${accountId}`;
exports.getRedoMigrationNoticeDismissKey = getRedoMigrationNoticeDismissKey;
const isRedoMigrationNoticeDismissed = (accountId) => sessionStorage.getItem((0, exports.getRedoMigrationNoticeDismissKey)(accountId)) ===
    'true';
exports.isRedoMigrationNoticeDismissed = isRedoMigrationNoticeDismissed;
const dismissRedoMigrationNotice = (accountId) => {
    sessionStorage.setItem((0, exports.getRedoMigrationNoticeDismissKey)(accountId), 'true');
};
exports.dismissRedoMigrationNotice = dismissRedoMigrationNotice;
const clearRedoMigrationNoticeDismissals = () => {
    Object.keys(sessionStorage)
        .filter((key) => key.startsWith(DISMISS_KEY_PREFIX))
        .forEach((key) => sessionStorage.removeItem(key));
};
exports.clearRedoMigrationNoticeDismissals = clearRedoMigrationNoticeDismissals;
